export const ICE_CONFIG = {
  iceServers: [
    {
      urls: [
        "stun:stun.l.google.com:19302",
        "stun:global.stun.twilio.com:3478",
      ],
    },
    {
      urls: [
        "turn:stun.evan-brass.net",
        "turn:stun.evan-brass.net?transport=tcp",
        "turn:stun.evan-brass.net?transport=udp",
        "stun:stun.evan-brass.net",
      ],
      username: "guest",
      credential: "password",
    },
    {
      urls: [
        "turn:turn.pickitforme.com",
        "turn:turn.pickitforme.com?transport=tcp",
        "turn:turn.pickitforme.com?transport=udp",
        "stun:stun.pickitforme.com",
      ],
      username: "user1",
      credential: "password1",
    },
  ],
};